import React from 'react';
import _ from 'lodash';

import { useShipItemFieldQuery } from 'generated/graphql';



export interface IShipItem {
  id: string;
  name: string;
}

export interface IData {
  objects: IShipItem[];
}

export function useQuery(subsidiaryId: string) {
  const tuple = useShipItemFieldQuery({
    variables: {
      subsidiaryId
    }
  });

  const wrappedTuple = React.useMemo(() => {
    const data: IData = {
      objects: _.map(tuple.data?.shipItems.nodes ?? [], (node): IShipItem => ({
        id: node.id,
        name: node.name
      }))
    };

    return {
      loading: tuple.loading,
      data,
      refetch: async () => {
        tuple.refetch({});
      }
    };
  }, [tuple]);

  return wrappedTuple;
}
